import { render } from "./SignSaleForOnePage.vue?vue&type=template&id=52147765&scoped=true"
import script from "./SignSaleForOnePage.vue?vue&type=script&lang=js"
export * from "./SignSaleForOnePage.vue?vue&type=script&lang=js"

import "./SignSaleForOnePage.vue?vue&type=style&index=0&id=52147765&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52147765"]])

export default __exports__